import React from "react";
import { Container } from "react-bootstrap";
import NavBar from "./navbar";
import Footer from "./footer";

function Home() {
  return (
    <div>
      <NavBar />
      <section className="page-content">
        <Container style={{ "margin-top": "6%"}}>
          <div className="home-text">
              {/* <h1><b>Aryan Kenchappagol</b></h1> */}
              <div style={{ "margin-top": "7%", backgroundColor: "" }}>
                <p align="justify">
                  Hi there, welcome to my space.
                </p>
                <p align="justify">
                  I’m <b><a href="https://www.linkedin.com/in/aryan-kenchappagol/">Aryan Kenchappagol</a></b>, a Computer Science Engineer, based in Pune, India. My interests primarily revolve around Machine Learning for Medical Imaging. You can head to <b><a href="https://scholar.google.com/citations?user=p02GuvsAAAAJ&hl=en">Google Scholar</a></b> to see my work. 
                  
                  <p></p>Additionally I enjoy exploring and contributing to open source projects. 
                  
 
                  I have worked with and contributed to organisations <b><a href="https://www.osgeo.org/">OSGeo</a></b>, <b><a href="https://strideai.in/">Stride AI</a></b>, <b><a href="https://www.espressif.com/">Espressif Systems</a></b>, <b><a href="https://github.com/OWASP/www-project-machine-learning-security-top-10">OWASP</a></b>, <b><a href="https://www.crowdsec.net/">CrowdSec</a></b>, <b><a href="https://github.com/developmentseed/lonboard">Lonboard</a></b> as an Open Source Contributor across backend development, machine learning,
                  and natural language processing. I was also a <b><a href="https://drive.google.com/file/d/1x5y6yWvm5OwVMkWHMBjOKQul9o68T3nQ/view?usp=sharing">Google Summer of
                  Code</a></b> student, contributing to open-source geoinformatics
                  software. Software engineering has always been my forte, and I
                  genuinely enjoy keeping up with the latest technologies and
                  building with them.
                </p>
                <p align="justify">
                  I aspired to become a <b>bureaucrat</b>, so I appeared for the UPSC Civil Services Examination (in '24, '25 and '26) thrice, one of India's toughest public examinations, gaining extensive knowledge across diverse fields such as International Relations, Polity, Micro and Macro Economics, Governance, Disaster Management and others. It was a dream I pursued wholeheartedly after completing my bachelor's degree.
                  But life had other plans. Now, I’m returning to software
                  engineering, with the drive to build meaningful products with
                  cutting-edge technology. It feels like the right path, and I
                  can’t wait to see where it leads me.
                </p>
                <p align="justify">
                  Welcome, and I hope you enjoy exploring my work.
                </p>
                <div align="left">
                  <p>So far, a few things from my career:</p>
                  <ul>
                    <li>
                      Received the <b><a href="https://drive.google.com/file/d/1lBwpsQ-xo8mg2btjuM9CDsutLOkU3qzp/view">Best Paper Award</a></b> for Comparative Study of Machine Learning Algorithms for Breast Cancer Classification, at the 2nd International Conference on Intelligent and Cloud Computing (ICICC-2021). 
                    </li>
                    <li>
                      Selected among the <b>top 10</b> finalists from over <b>10,000</b> applicants across India for the <b><a href="https://www.newindianexpress.com/business/2019/Nov/26/hyundai-motor-india-foundation-announces-h-social-creator-award-winners--2067272.html">Hyundai Social Creators</a></b>, New Delhi, India.
                    </li>
                    <li>
                      Secured 1st place among 30 teams at the <a href="https://www.isquareit.edu.in/event/fe-student-teams-from-i%C2%B2it-for-winning-the-first-and-the-second-prize-at-the-barclays-tech-innovation-challenge-2019/"><b>Barclays Tech Innovation Challenge</b></a> in Pune, India.
                    </li>
                    <li>
                      Selected among the top 20 teams for the <b><a href="https://events.vtools.ieee.org/m/350614">Pune Smart Health Hackathon</a></b>, organised by the Pune Municipal Corporation
                      and IEEE Pune Section, with participants from four states.
                    </li>
                    <li>
                      Organised workshops and events on Artificial Intelligence,
                      Machine Learning, Google Summer of Code, and open-source
                      development as the Open Source Lead of the Google
                      Developer Student Club for 10 months.
                    </li>
                  </ul>
                </div>
              </div>
          </div>
          <br/>
          <br/>
          <br/>
        </Container>
      </section>
      <Footer/>
    </div>
  );
}

export default Home;
